"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migrateNumberSliderToNumberField = void 0;
const migrations_1 = require("../../migrations/migrations");
function migrateNumberSliderToNumberField(fieldTo, fieldFrom) {
    var _a;
    const migratedField = (0, migrations_1.migrateBaseField)(fieldTo, fieldFrom);
    return {
        ...migratedField,
        params: {
            ...migratedField.params,
            allow_negative: ((_a = fieldFrom.params.min_value) !== null && _a !== void 0 ? _a : 0) < 0,
        },
    };
}
exports.migrateNumberSliderToNumberField = migrateNumberSliderToNumberField;
